import { ActionsType } from "src/interfaces/Common";
import { ActivityType } from "src/interfaces/Activities";

export type DecompressionIcon = "error" | "warning";

export function getActivityDecompressionIcon(
  row: any,
): DecompressionIcon | null {
  if (
    row?.type !== ActivityType.DA_SCORM &&
    row?.type !== ActivityType.DA_XAPI
  ) {
    return null;
  }
  const result = row?.unarchive_result;
  if (result === null || result === undefined) return null;
  const status = result?.status;
  if (status === "KO") return "error";
  if (status !== "OK" && !result?.endDate) return "warning";
  return null;
}

export type ActivityUnarchiveState = "in-progress" | "failed";

export interface ActivityUnarchiveInfo {
  state: ActivityUnarchiveState;
  format: "SCORM" | "xAPI";
  errorMessage?: string;
}

export function getActivityUnarchiveInfo(
  entity: any,
): ActivityUnarchiveInfo | null {
  const type = entity?.type || entity?.learning_object_type;
  if (type !== ActivityType.DA_SCORM && type !== ActivityType.DA_XAPI) {
    return null;
  }
  const result = entity?.unarchive_result ?? entity?.unarchiveResult;
  if (result === null || result === undefined) return null;

  const format = type === ActivityType.DA_SCORM ? "SCORM" : "xAPI";
  const status = result?.status;
  if (status === "KO") {
    return {
      state: "failed",
      format,
      errorMessage: result?.errorMessage || result?.error_message || undefined,
    };
  }
  if (status !== "OK" && !(result?.endDate ?? result?.end_date)) {
    return { state: "in-progress", format };
  }
  return null;
}

export function buildActivityDecompressionAction(
  row: any,
  i18nLang: string,
  options: {
    permission: string;
    onClick?: (id: any) => void;
  },
): ActionsType | null {
  const icon = getActivityDecompressionIcon(row);
  if (!icon) return null;
  return {
    key: "decompression",
    type: "decompression",
    permission: options.permission,
    label: { en: "Status", it: "Stato" },
    labelTranslate: i18nLang === "it" ? "Stato" : "Status",
    icon,
    callBack: options.onClick,
  } as unknown as ActionsType;
}
